<template lang="pug">
  .save-info-2-element
    b-card.mb-0.card-inactive.p-2(no-body)
      fieldset(:disabled="disabled")
        b-form-group(v-for="e_a in Element_Attributes", :key="e_a.element_attribute_id", v-if="e_a.name === 'data'", :id="`element_attribute_${e_a.element_attribute_id}`")
          template(#label)
            .d-flex.justify-content-between
              .text-sm Datos:
                span.ml-2.text-sm.text-success(v-if="isNew") Nuevo
              x-icon.icon-md.hover-danger.pointer.text-secondary(v-if="!disabled", @click="$emit('destroy', element_id)")
          vue-tribute(:options="tributeOpts")
            b-form-input.disabled-white(placeholder="Datos", :value="e_a.value", @input="updateElementAttribute(e_a, $event)", size="sm")
        b-form-row
          b-col(md="6", v-for="e_a in Element_Attributes", :key="e_a.element_attribute_id", v-if="e_a.name === 'placement'")
            b-form-group(label="Posición:", label-size="sm", :id="`element_attribute_${e_a.element_attribute_id}`")
              b-form-select(:value="e_a.value || null", @change="updateElementAttribute(e_a, $event)", size="sm")
                option(:value="null", disabled) --Selecciona posición--
                option(v-for="place in placements", :key="place.value", :value="place.value") {{place.title}}
          b-col(md="6", v-for="e_a in Element_Attributes", :key="e_a.element_attribute_id", v-if="e_a.name === 'type'")
            b-form-group(label="Tipo de dato:", label-size="sm", :id="`element_attribute_${e_a.element_attribute_id}`")
              b-form-select(:value="e_a.value || null", @change="updateElementAttribute(e_a, $event)", size="sm")
                option(:value="null", disabled) --Selecciona tipo--
                option(v-for="type in parse_types", :key="type.value", :value="type.value") {{type.title}}
</template>

<script>
import templateElementCommon from '@/helpers/template-element-common'
import _debounce from 'lodash.debounce'

export default {
  data () {
    return {
      types: [
        {value: "image", title: "Imagen"},
        {value: "video", title: "Video"},
        {value: "text", title: "Texto"},
        {value: "document", title: "Documento"},
      ],
      placements: [
        {value: "header", title: "Encabezado"},
        {value: "body", title: "Cuerpo de mensaje"},
      ]
    }
  },
  computed: {
    parse_types () {
      let attribute = this.Element_Attributes.find(attribute => attribute.name === "placement")
      if (attribute && attribute.value && attribute.value === 'body') {
        return [{value: "text", title: "Texto"}]
      }
      return this.types
    }
  },
  mixins: [templateElementCommon],
  created () {
    this.updateElementAttribute = _debounce((element_attribute, value) => {
      let attribute = JSON.parse(JSON.stringify(element_attribute))
      attribute.value = value
      console.log(attribute);
      this.updateAttribute(this.block_id, this.template_id, this.element_id, attribute)
    }, 2000, {leading: false, trailing: true})
  },
}
</script>

<style lang="scss" scoped>

  .save-info-2-element {

    &:not(:last-child) {
      margin-bottom: 1rem;
    }
  }
</style>
